import template from './unete.component.html';
import angular from 'angular';
import './unete.repository';



angular
    .module('Toke')
    .component('appUnete', {
        template,
        bindings: {
            data: '<'
        },
        controller: UneteController
    });



UneteController.$inject = ['uneteRepository'];

function UneteController(uneteRepository) {
    const vm = this;

    vm.unete = {};

    vm.$onInit = function () {

        if (vm.data && vm.data.list) {
            vm.unete = vm.data;

        } else {
            uneteRepository.getUnete().then(res => {
                vm.unete = res || {};

            });
        }
    };
}
